import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M5 21.5V20h15v1.5zm7.49-3.885-6.307-8.22h3.634V2.5h5.356v6.894h3.635zm0-2.442 3.237-4.27h-2.054V4h-2.356v6.904H9.264z" }, null, -1)
  ])))
}
export default { render: render }